import { Card, Spin } from 'antd';
import AuthLayout from '../layout/AuthLayout'
import AppVersion from '../../components/AppVersion';
import { useSignOut } from 'react-auth-kit';
import { useEffect } from 'react';
import { removeToken } from '@qlibs/utils';

const Logout = () => {
  const signOut = useSignOut();

  useEffect(() => {
    removeToken();
    signOut();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
	return (
    <AuthLayout>
      <Card style={{ width: 500 }} bordered={false}>
        <Spin />
        <AppVersion />
      </Card>
    </AuthLayout>
  );
}

export default Logout